import { render, staticRenderFns } from "./ValidationSection.vue?vue&type=template&id=63c9a6d6&scoped=true"
import script from "./ValidationSection.vue?vue&type=script&lang=js"
export * from "./ValidationSection.vue?vue&type=script&lang=js"
import style0 from "./ValidationSection.vue?vue&type=style&index=0&id=63c9a6d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9a6d6",
  null
  
)

export default component.exports